module.exports = __webpack_public_path__ + "static/img/6.8571ac2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/6.png
// module id = DeQh
// module chunks = 0